const FETCH_COLLABORATORS_INFO = 'contactos-permisos/collaborators/FETCH_COLLABORATORS_INFO';
const FETCH_COLLABORATORS_INFO_COMPLETED = 'contactos-permisos/collaborators/FETCH_COLLABORATORS_INFO_COMPLETED';
const FETCH_COLLABORATORS_INFO_FAILED = 'contactos-permisos/collaborators/FETCH_COLLABORATORS_INFO_FAILED';
const GET_POSTING_INFO = 'contactos-permisos/collaborators/GET_POSTING_INFO';
const GET_POSTING_INFO_COMPLETED = 'contactos-permisos/collaborators/GET_POSTING_INFO_COMPLETED';
const GET_POSTING_INFO_FAILED = 'contactos-permisos/collaborators/GET_POSTING_INFO_FAILED';
const UPDATE_USER_PERMISSIONS = 'contactos-permisos/collaborators/UPDATE_USER_PERMISSIONS';
const UPDATE_USER_PERMISSIONS_COMPLETED = 'contactos-permisos/collaborators/UPDATE_USER_PERMISSIONS_COMPLETED';
const UPDATE_USER_PERMISSIONS_FAILED = 'contactos-permisos/collaborators/UPDATE_USER_PERMISSIONS_FAILED';

export {
  FETCH_COLLABORATORS_INFO,
  FETCH_COLLABORATORS_INFO_COMPLETED,
  FETCH_COLLABORATORS_INFO_FAILED,
  GET_POSTING_INFO,
  GET_POSTING_INFO_COMPLETED,
  GET_POSTING_INFO_FAILED,
  UPDATE_USER_PERMISSIONS_FAILED,
  UPDATE_USER_PERMISSIONS_COMPLETED,
  UPDATE_USER_PERMISSIONS
};
